// extracted by mini-css-extract-plugin
export default {"genericButton":"ReportButton_genericButton__XcIaG","icon":"ReportButton_icon__DYZVm","baseline":"ReportButton_baseline__PL2Re","buttonText":"ReportButton_buttonText__vMk-K"};